import React, { useEffect, useState } from 'react'
import { TextField, MenuItem, SxProps, Theme } from '@mui/material'
import { TypeVas } from '../../interfaces/TypeVas/TypeVas'
import { useTypeVas } from '../../hooks/useTypeVas'

interface TypeVasDDLProps {
  onChange: any
  value: any
  type?: 'outlined' | 'filled' | 'standard' | undefined
  fullWidth?: boolean
  valueKey?: 'typeVasId' | 'name'
  required?: boolean
  disabled?: boolean
  size?: 'small' | 'medium' | undefined
  sx?: SxProps<Theme>
}

export const TypeVasDDL: React.FC<TypeVasDDLProps> = ({
  onChange,
  value,
  type,
  fullWidth = false,
  valueKey = 'typeVasId',
  required = false,
  disabled = false,
  size,
  ...otherProps
}) => {
  const [hasError, setHasError] = useState<boolean>(false)

  const {
    typeVasState: { typeVas },
    getTypeVas
  } = useTypeVas()

  useEffect(() => {
    if (typeVas?.length === 0) {
      getTypeVas()
    }
  }, [])

  useEffect(() => {
    // Validar si es obligatorio y si se ha seleccionado alguna opción
    if (required && value < 1) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [value, required])

  const arrTypeVas =
    typeVas !== undefined
      ? typeVas.map((option: TypeVas) => (
          <MenuItem key={option[valueKey]} value={option[valueKey]}>
            {option.name}
          </MenuItem>
        ))
      : []

  return (
    <TextField
      variant={type}
      id='typeVasId'
      name='typeVasId'
      select
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      disabled={disabled}
      size={size}
      error={hasError}
      helperText={hasError ? 'Seleccionar Tipo de VAS' : undefined}
      {...otherProps}
    >
      <MenuItem key={0} value={0}>
        {'Seleccione Tipo ...'}
      </MenuItem>
      {arrTypeVas}
    </TextField>
  )
}
